import Service, { getCallApiFunction } from '../service'

export type ParamsType = {
  productId: number
}

class SetProductHiddenApi extends Service {
  constructor({ productId }: ParamsType) {
    super()
    this.name = 'SET_PRODUCT_HIDDEN'

    this.config = {
      url: `/v1/livemall/product/launched`,
      method: 'DELETE',
      data: {
        productId,
      },
    }
  }
}

class UndoProductHiddenApi extends Service {
  constructor({ productId }: ParamsType) {
    super()
    this.name = 'UNSET_PRODUCT_HIDDEN'
    this.config = {
      url: `/v1/livemall/product/launched`,
      method: 'POST',
      data: {
        productId,
      },
    }
  }
}

export const setProductHidden = (params: ParamsType) => getCallApiFunction(new SetProductHiddenApi(params))
export const undoProductHidden = (params: ParamsType) => getCallApiFunction(new UndoProductHiddenApi(params))
